"use strict";
var appn;
(function (appn) {
    var localStorage;
    (function (localStorage) {
        const _clearLsKey = 'freshLs-Web30Mar2022';
        function getItem(key) {
            let item = null;
            try {
                const lsValue = window.localStorage.getItem(key);
                item = lsValue ? JSON.parse(lsValue) : null;
            }
            catch (e) {
                if (e && e.message)
                    console.log(e.message);
            }
            return item;
        }
        localStorage.getItem = getItem;
        function setItem(key, value) {
            let isSet = true;
            try {
                window.localStorage.setItem(key, JSON.stringify(value));
            }
            catch (e) {
                isSet = false;
                if (e && e.message)
                    appn.log.error(e.message, true);
            }
            return isSet;
        }
        localStorage.setItem = setItem;
        function removeItem(key) {
            try {
                window.localStorage.removeItem(key);
            }
            catch (e) {
                if (e && e.message)
                    console.log(e.message);
            }
        }
        localStorage.removeItem = removeItem;
        function clearAll() {
            try {
                window.localStorage.clear();
            }
            catch (e) {
                if (e && e.message)
                    console.log(e.message);
            }
        }
        localStorage.clearAll = clearAll;
        function autoClearLs() {
            const hasLsBeenAutoCleared = appn.localStorage.getItem(_clearLsKey);
            if (hasLsBeenAutoCleared)
                return;
            clearAllAndSetFreshLs();
        }
        localStorage.autoClearLs = autoClearLs;
        function clearAllAndSetFreshLs() {
            appn.localStorage.clearAll();
            appn.localStorage.setItem(_clearLsKey, true);
        }
        localStorage.clearAllAndSetFreshLs = clearAllAndSetFreshLs;
    })(localStorage = appn.localStorage || (appn.localStorage = {}));
})(appn || (appn = {}));
